import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Collapse,
  makeStyles,
} from '@material-ui/core';
import { countSelectedSarau, getSarauFieldKeys } from './config';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 4,
    color: '#1a3a5c',
  },
  subtitle: {
    textAlign: 'center',
    color: '#5a7a9a',
    marginBottom: theme.spacing(3),
  },
  optionCard: {
    border: '1px solid #e0e0e0',
    borderRadius: 12,
    padding: theme.spacing(1.5, 2),
    transition: 'all 0.2s',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    height: '100%',
    '&:hover': {
      borderColor: '#bbb',
    },
  },
  optionCardSelected: {
    border: '2px solid #1a3a5c',
    backgroundColor: '#f5f8fc',
  },
  fullWidthCard: {
    border: '1px solid #e0e0e0',
    borderRadius: 12,
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(1.5),
    transition: 'all 0.2s',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#bbb',
    },
  },
  fullWidthCardSelected: {
    border: '2px solid #1a3a5c',
    backgroundColor: '#f5f8fc',
  },
}));

const DEFAULT_OPT_OUT = {
  id: 'nao_participar_sarau',
  name: 'Não irei participar do Sarau',
  active: true,
  special_type: 'opt_out',
  extra_text: { enabled: false, required: false, label: '' },
};

export default function StepSarau({ formData, updateNestedFormData, activityConfig }) {
  const classes = useStyles();
  const s = formData.sarau_activities || {};
  const allOptions = activityConfig?.sarau || [];
  const sarauLimit = activityConfig?.sarauLimit || 3;
  const optOutOption =
    allOptions.find((item) => item.special_type === 'opt_out') || DEFAULT_OPT_OUT;
  const sarauOptions = allOptions.filter((item) => item.special_type !== 'opt_out');
  const optOutSelected = !!s[optOutOption.id];

  const activityCount = countSelectedSarau(s, allOptions);

  const handleToggle = (item) => {
    if (item.special_type === 'opt_out') {
      sarauOptions.forEach((option) => updateNestedFormData('sarau_activities', option.id, false));
      updateNestedFormData('sarau_activities', item.id, !s[item.id]);
    } else {
      if (optOutOption && optOutSelected) {
        updateNestedFormData('sarau_activities', optOutOption.id, false);
      }
      updateNestedFormData('sarau_activities', item.id, !s[item.id]);
    }
  };

  return (
    <Box>
      <Typography variant="h5" className={classes.title}>
        Sarau Cultural
      </Typography>
      <Typography variant="body2" className={classes.subtitle}>
        Selecione até {sarauLimit} atividades culturais para participar
      </Typography>

      <Grid container spacing={2}>
        {sarauOptions.map((option) => {
          const keys = getSarauFieldKeys(option);
          const checked = s[option.id];
          const disabled = !checked && option.special_type !== 'opt_out' && activityCount >= sarauLimit && !optOutSelected;

          return (
            <Grid item xs={12} sm={6} key={option.id}>
              <Box
                className={`${classes.optionCard} ${checked ? classes.optionCardSelected : ''}`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={() => handleToggle(option)}
                      disabled={disabled}
                      color="primary"
                    />
                  }
                  label={<Typography variant="body1">{option.name}</Typography>}
                />
                {option.extra_text?.enabled && (
                  <Collapse in={checked}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label={option.extra_text.label}
                      value={s[keys.details] || ''}
                      onChange={(e) =>
                        updateNestedFormData('sarau_activities', keys.details, e.target.value)
                      }
                      style={{ marginTop: 8 }}
                    />
                  </Collapse>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Box
        className={`${classes.fullWidthCard} ${optOutSelected ? classes.fullWidthCardSelected : ''}`}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={optOutSelected}
              onChange={() => handleToggle(optOutOption)}
              color="primary"
            />
          }
          label={
            <Typography variant="body1">
              {optOutOption.name}
            </Typography>
          }
        />
      </Box>
    </Box>
  );
}
